import loadable from '@wix/yoshi-flow-editor/loadable'

export const StatusScreensEntry = loadable(
  () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "status-screens" */ '../router/status-screens-entry/status-screens-entry'
    ),
)
